import type { ContentMap } from "./types";

export const contentAU: ContentMap = {
  // Hero
  "hero-eyebrow": "For locum doctors across Australia",
  "hero-h1": 'Stop chasing.<br>Start <span>working.</span>',
  "hero-sub":
    "Every participating agency in Australia. Your speciality, your grade, your availability. One tap to apply. No more inbox chaos.",

  // Problem
  "problem-h2": "Your phone became a job board you never signed up for.",
  "problem-p1":
    "Four agency apps. Three WhatsApp groups. A recruiter calling about Perth ED when you're based in Sydney. The same role listed by two agencies at different rates — and neither shows what you'll actually earn.",
  "problem-p2":
    "You chose locum work for autonomy, not to spend an hour every morning triaging messages from people who don't know your speciality.",
  "problem-closer": "That stops here.",

  // HIW prefs card values
  "hiw-prefs-loc": "Sydney · ≤25km",
  "hiw-prefs-rate": "≥ A$250/hr",

  // HIW phone card
  "hiw-phone-title": "GP Locum · Parramatta",
  "hiw-phone-rate": "A$280/hr",
  "hiw-phone-card2": "Locum GP · Bondi · 5km",
  "hiw-phone-card3": "Reg · Sydney CBD · ≤20km",

  // HIW apply card
  "hiw-job-title": "GP Locum · Parramatta",
  "hiw-ag0-rate": "A$280/hr",
  "hiw-ag0-name": "CC Medical",
  "hiw-ag1-rate": "A$275/hr",
  "hiw-ag1-name": "Ochre Health",
  "hiw-ag2-rate": "A$285/hr",
  "hiw-ag2-name": "Cornerstone Med",

  // Differentiator: credential
  "diff-cred-h3": "Credential verified once",
  "diff-cred-p":
    "AHPRA verification done once, valid everywhere. No more re-uploading documents for every agency you work with.",

  // Testimonials
  "test-heading": "What doctors are telling us.",
  "test-disclaimer":
    "From conversations with locum doctors during our pre-launch research. Names changed for privacy.",
  "test1-quote":
    '\u201cI check four apps every morning before I even have coffee. If someone could put it all in one place, I\u2019d switch tomorrow.\u201d',
  "test1-avatar": "S",
  "test1-name": "Emergency physician",
  "test1-title": "Sydney, NSW",
  "test2-quote":
    '\u201cSame role, three agencies, three rates. I just want to see the best one and apply. That\u2019s it.\u201d',
  "test2-avatar": "J",
  "test2-name": "General practitioner",
  "test2-title": "Melbourne, VIC",
  "test3-quote":
    '\u201cI don\u2019t want a 7pm call about tomorrow\u2019s theatre list. Let me set what I want and just get matched.\u201d',
  "test3-avatar": "P",
  "test3-name": "Anaesthetist",
  "test3-title": "Brisbane, QLD",

  // Trust strip
  "trust-cred-title": "AHPRA verified",
  "trust-cred-desc":
    "Every doctor credential-checked via AHPRA before they see a single role",

  // CTA
  "cta-p":
    "Join the waitlist. Be first to access every locum role in Australia — from every participating agency, in one place.",

  // Footer
  "footer-desc":
    "Every locum role, every agency, in one place. Built for Australian doctors who want their time back.",
  "footer-made": "Made in Australia",

  // Nav
  "nav-doctors": "For doctors",
  "nav-agencies": "For agencies",
  "nav-hospitals": "Hospitals",
  "nav-cta": "Register interest",

  // Hero buttons & proof
  "hero-cta1": "Get early access",
  "hero-cta2": "How it works",
  "waitlist-success": "You\u2019re on the list. We\u2019ll be in touch.",
  "waitlist-success-cta": "You\u2019re on the list. We\u2019ll be in touch.",
  "waitlist-hint": "No spam. Just early access when we launch.",
  "proof-1": "Rates on every listing",
  "proof-2": "Matched to your specialty",
  "proof-3": "Apply in one tap",
  "proof-4": "All agencies. One feed.",
  "proof-5": "Credential verified",
  "phone-date": "Monday, 14 April",

  // Differentiators
  "diff-heading": "What Locum Plus gives you that no one else can.",
  "diff-feed-h3": "Every agency. One Locum Plus feed.",
  "diff-feed-p":
    "Stop switching between four apps. Locum Plus aggregates every participating agency's roles in one place, deduplicated and matched to your profile.",
  "diff-rates-h3": "Rates always visible",
  "diff-rates-p":
    "Every listing shows the rate upfront. No guessing, no awkward calls. You see what you'll earn before you apply.",
  "diff-apply-h3": "Apply in seconds, not hours",
  "diff-apply-p":
    "One tap. No cover letters, no phone tag. Track every application in real time from the same screen.",
  "diff-match-h3": "Matched to your preferences",
  "diff-match-p":
    "Grade, speciality, location radius, rate floor. The feed adapts to you — not the other way around.",
  "diff-ops-h3": "Built by operators, not consultants",
  "diff-ops-p":
    "Decades of healthcare staffing experience behind every feature. This was made with agencies, not against them.",

  // Specialities
  "spec-heading": "Every speciality. Every grade.",
  "spec-sub":
    "From emergency medicine to GP obstetrics — matched to your credentials.",
  "spec-chips":
    '<div class="speciality-chip">Emergency Medicine</div><div class="speciality-chip">General Practice</div><div class="speciality-chip">Anaesthetics</div><div class="speciality-chip">Paediatrics</div><div class="speciality-chip">Orthopaedics</div><div class="speciality-chip">Psychiatry</div><div class="speciality-chip">O&amp;G</div><div class="speciality-chip">Internal Medicine</div><div class="speciality-chip">ICU / Critical Care</div><div class="speciality-chip">Radiology</div><div class="speciality-chip">Surgery</div><div class="speciality-chip">GP Obstetrics</div>',

  // Experience stories
  "exp-heading": "Built around real locum life.",
  "exp-intro": "Not how agencies think you work — how you actually do.",
  "exp1-h3": "Set it once, from anywhere",
  "exp1-p":
    "Speciality, grade, location radius, minimum rate. Your Locum Plus preferences filter everything — so the feed only shows roles you'd actually take.",
  "exp2-h3": "Every agency. One Locum Plus feed.",
  "exp2-p":
    "Every participating agency's listings, deduplicated, matched, and ranked. Rates visible on every card. Updated in real time, not once a day.",
  "exp3-h3": "One tap. Back to your coffee.",
  "exp3-p":
    "No cover letters. No phone calls. No re-uploading your CV. Apply, track, confirm — all from the same screen on Locum Plus.",

  // Personas
  "persona-heading": "Built for how you actually work.",
  "persona-intro":
    "Locum isn't a gap year. It's a career strategy. Every feature is designed around the five ways doctors actually use flexible work.",
  "per1-h3": "The parent who needs school hours",
  "per1-p":
    "Work term time. Take summers off. Drop to two shifts a week without a negotiation. Your schedule, not your employer's.",
  "per2-h3": "The doctor who left for a reason",
  "per2-p":
    "Hospital politics, admin burden, loss of clinical autonomy. Locum is the reset button: pure clinical care, clear outcomes, home by five.",
  "per3-h3": "The specialist keeping current",
  "per3-p":
    "50 hours CPD a year to maintain registration. Two shifts a month across different settings keeps knowledge sharp without the full-time grind.",
  "per4-h3": "The experience builder",
  "per4-p":
    "Registrar or international-trained, building a CV across multiple settings. Locum rotations that count toward fellowship, not filler shifts.",
  "per5-h3": "The rural adventurer",
  "per5-p":
    "Higher pay, lower costs, clinical variety. Two-week regional blocks that sharpen generalist skills and reset the mind.",

  // Audiences
  "aud-heading": "Same market. Two problems.<br>One platform.",
  "aud-doc-h3": "For doctors",
  "aud-doc-p":
    "Too many agencies. Too many messages. No visibility on rates. Locum Plus puts every role in one feed, matched to your profile. You decide what to apply for — not what to wade through.",
  "aud-doc-btn": "Join as a doctor",
  "aud-ag-h3": "For agencies",
  "aud-ag-p":
    "Your best candidates are drowning in messages from your competitors. Forward client requests once — matched doctors apply automatically. No spreadsheets, no chasing doctors by phone.",
  "aud-ag-btn": "Partner with us",

  // Trust
  "trust-enc-title": "Bank-grade encryption",
  "trust-enc-desc":
    "Your data encrypted at rest and in transit, always",
  "trust-ops-title": "Built by operators",
  "trust-ops-desc":
    "Decades of healthcare staffing behind every feature",

  // CTA section
  "cta-h2": 'Your next shift<br>is <span>waiting.</span>',
  "cta-btn": "Get early access",

  // Footer columns
  "foot-col1-title": "Product",
  "foot-col1-links":
    '<li><a href="#audiences">For doctors</a></li><li><a href="#audiences">For agencies</a></li><li><a href="#hiw-section">How it works</a></li><li><a href="#specialities">Specialities</a></li>',
  "foot-col2-title": "Company",
  "foot-col2-links":
    '<li><span class="footer-link-disabled">About</span></li><li><a href="mailto:info@locumgroup.co">Contact</a></li><li><span class="footer-link-disabled">Careers</span></li><li><span class="footer-link-disabled">Blog</span></li>',
  "foot-col3-title": "Legal",
  "foot-col3-links":
    '<li><a href="/privacy">Privacy</a></li><li><a href="/terms">Terms</a></li><li><span class="footer-link-disabled">Security</span></li>',
  "footer-copy": "&copy; 2026 Locum Plus. All rights reserved.",

  // HIW big title
  "hiw-pill": "HOW IT WORKS",
  "hiw-hl1": "Chaos in.",
  "hiw-hl2": "Matched roles out.",
  "hiw-scroll-hint":
    "Scroll to see how we turn agency spam into a single feed of jobs that match you.",

  // HIW mobile fallback
  "hiw-pill-mobile": "HOW IT WORKS",
  "hiw-mobile-h": "Chaos in. Matched roles out.",
  "hiw-mobile-sub":
    "How Locum Plus turns agency spam into a single feed of jobs that match you.",
  "hiw-mob-s1-h": "Chaos arrives",
  "hiw-mob-s1-p":
    "Every agency blasts out every role \u2014 plus calls, texts and WhatsApps chasing you for jobs you\u2019d never take.",
  "hiw-mob-s2-h": "Your preferences",
  "hiw-mob-s2-p":
    "Set grade, speciality, location range, rate and availability. Once.",
  "hiw-mob-s3-h": "Matches revealed",
  "hiw-mob-s3-p":
    "Locum Plus tags each role against your preferences \u2014 match or no-match, shown upfront.",
  "hiw-mob-s4-h": "Landed in the app",
  "hiw-mob-s4-p":
    "Matched jobs land in one feed. No duplicate listings, no more phone tag.",
  "hiw-mob-s5-h": "Apply your way",
  "hiw-mob-s5-p":
    "One job. Your pick of the agencies running it. Apply in one tap.",

  // HIW stepper labels
  "hiw-step1": "Chaos arrives",
  "hiw-step2": "Your preferences",
  "hiw-step3": "Matches revealed",
  "hiw-step4": "Landed in the app",
  "hiw-step5": "Apply your way",

  // HIW phase headings & subs
  "hiw-ph0-h": "Chaos arrives",
  "hiw-ph0-sub":
    "Every agency blasts out every role — plus calls, texts and WhatsApps chasing you for jobs you'd never take.",
  "hiw-ph1-h": "Your preferences",
  "hiw-ph1-sub":
    "Set grade, speciality, location range, rate and availability. Once.",
  "hiw-ph2-h": "Matches revealed",
  "hiw-ph2-sub":
    "Locum Plus tags each role against your preferences — match or no-match, shown upfront.",
  "hiw-ph3-h": "Landed in the app",
  "hiw-ph3-sub":
    "Matched jobs land in one feed. No duplicate listings, no more phone tag.",
  "hiw-ph4-h": "Apply your way",
  "hiw-ph4-sub":
    "One job. Your pick of the agencies running it. Apply in one tap.",

  // HIW prefs card
  "hiw-prefs-badge": "PREFERENCES",
  "hiw-prefs-title": "Your Locum+ filter",
  "hiw-prefs-l-grade": "Grade",
  "hiw-prefs-v-grade": "Consultant · Reg · GP",
  "hiw-prefs-l-spec": "Speciality",
  "hiw-prefs-v-spec": "General Practice",
  "hiw-prefs-l-loc": "Location",
  "hiw-prefs-l-rate": "Rate",
  "hiw-prefs-l-shifts": "Shifts",
  "hiw-prefs-v-shifts": "Day only",

  // HIW phone/apply card
  "hiw-feed-title": "My Feed",
  "hiw-feed-matches": "5 MATCHES",
  "hiw-match-badge": "MATCH",
  "hiw-phone-verified": "● VERIFIED",
  "hiw-view-agencies": "VIEW · 3 AGENCIES",
  "hiw-apply-title": "Apply",
  "hiw-job-agencies": "1 JOB · 3 AGENCIES",
  "hiw-verified": "VERIFIED",
  "hiw-apply-via": "APPLY VIA",
  "hiw-apply-caption": "One job. Your pick of the agency.",
  "hiw-badge-verified": "Verified",
  "hiw-badge-trusted": "Trusted",
  "hiw-badge-fastest": "Fastest reply",
};
